import { z } from "zod";
export const StepSpecSchema = z.object({
    id: z.string().min(1),
    title: z.string().min(1),
    description: z.string().optional(),
    agentCapability: z.string().min(1),
    inputs: z.record(z.string(), z.unknown()),
    outputs: z.array(z.string()),
    requiresApproval: z.boolean(),
    estimatedDurationMin: z.number().int().nonnegative().optional(),
    approvalGates: z.array(z.string()).optional(),
});
export const StepEdgeSchema = z.object({
    from: z.string(),
    to: z.string(),
});
export const StepGraphSchema = z
    .object({
    nodes: z.array(StepSpecSchema),
    edges: z.array(StepEdgeSchema),
})
    .superRefine((g, ctx) => {
    const ids = new Set(g.nodes.map((n) => n.id));
    let hasUnknownEdge = false;
    for (const e of g.edges) {
        if (!ids.has(e.from)) {
            ctx.addIssue({
                code: "custom",
                message: `unknown edge.from: ${e.from}`,
                path: ["edges"],
            });
            hasUnknownEdge = true;
        }
        if (!ids.has(e.to)) {
            ctx.addIssue({
                code: "custom",
                message: `unknown edge.to: ${e.to}`,
                path: ["edges"],
            });
            hasUnknownEdge = true;
        }
    }
    if (hasUnknownEdge)
        return;
    // Cycle detection via Kahn's algorithm.
    const indeg = new Map();
    for (const n of g.nodes)
        indeg.set(n.id, 0);
    for (const e of g.edges) {
        indeg.set(e.to, (indeg.get(e.to) ?? 0) + 1);
    }
    const queue = [];
    indeg.forEach((d, id) => {
        if (d === 0)
            queue.push(id);
    });
    let visited = 0;
    while (queue.length > 0) {
        const id = queue.shift();
        visited++;
        for (const e of g.edges) {
            if (e.from === id) {
                const next = (indeg.get(e.to) ?? 0) - 1;
                indeg.set(e.to, next);
                if (next === 0)
                    queue.push(e.to);
            }
        }
    }
    if (visited !== g.nodes.length) {
        ctx.addIssue({
            code: "custom",
            message: "cycle detected in step graph",
            path: ["edges"],
        });
    }
});
